// Update the global widget state
export interface ClearWidgetFormErrorAction {
  type: "CLEAR_WIDGET_FORM_ERROR";
  path: string;
}

export function clearWidgetFormError(path: string): ClearWidgetFormErrorAction {
  return {
    type: "CLEAR_WIDGET_FORM_ERROR",
    path,
  };
}
